import * as React from "react";

export const NextjsIcon = ({ className }: { className?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="25"
    strokeLinejoin="round"
    color="currentcolor"
    data-testid="geist-icon"
    viewBox="0 0 16 16"
    className={`${className}`}
  >
    <g clipPath="url(#clip0_53_108)">
      <circle
        cx="8"
        cy="8"
        r="7.375"
        stroke="currentColor"
        strokeLinecap="round"
      ></circle>
      <path
        stroke='url("#paint0_linear_53_108r1uk")'
        strokeMiterlimit="1.414"
        d="M10.63 11V5"
      ></path>
      <path
        fill='url("#paint1_linear_53_108r1uk")'
        fillRule="evenodd"
        d="M5.995 5h-1.25v6h1.25V6.968l6.366 7.74q.527-.344.992-.763z"
      ></path>
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_53_108r1uk"
        x1="11.13"
        x2="11.13"
        y1="5"
        y2="11"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff"></stop>
        <stop offset="0.609" stopColor="#fff" stopOpacity="0.57"></stop>
        <stop offset="0.797" stopColor="#fff" stopOpacity="0"></stop>
        <stop offset="1" stopColor="#fff" stopOpacity="0"></stop>
      </linearGradient>
      <linearGradient
        id="paint1_linear_53_108r1uk"
        x1="9.938"
        x2="13.557"
        y1="9.063"
        y2="13.399"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff"></stop>
        <stop offset="1" stopColor="#fff" stopOpacity="0"></stop>
      </linearGradient>
      <linearGradient
        id="paint0_linear_53_108r1uk"
        x1="11.13"
        x2="11.13"
        y1="5"
        y2="11"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff"></stop>
        <stop offset="0.609" stopColor="#fff" stopOpacity="0.57"></stop>
        <stop offset="0.797" stopColor="#fff" stopOpacity="0"></stop>
        <stop offset="1" stopColor="#fff" stopOpacity="0"></stop>
      </linearGradient>
      <linearGradient
        id="paint1_linear_53_108r1uk"
        x1="9.938"
        x2="13.557"
        y1="9.063"
        y2="13.399"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff"></stop>
        <stop offset="1" stopColor="#fff" stopOpacity="0"></stop>
      </linearGradient>
      <clipPath id="clip0_53_108">
        <path fill="red" d="M0 0h16v16H0z"></path>
      </clipPath>
    </defs>
  </svg>
);

